module.exports = __webpack_public_path__ + "static/media/61.47d15c65.png";